import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = ({ href, target, children, className }) => {
  return (
    <a className={`inline-flex items-center hover:opacity-75 ${className}`} href={href} target={target}>
      <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
        <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/>
      </svg>
      <span>{ children }</span>
    </a>
  );
};

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.oneOf([
    '_blank', '_self', '_parent', '_top',
  ]),
  className: PropTypes.string,
};

ExternalLink.defaultProps = {
  target: '_self',
};

export default ExternalLink;
